
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Login() {
 
  AnimationFileLoader();

  return (
    <>
      {/* Login */}
      <div
        className="py-5 d-flex align-items-center"
        id="loginDiv"
        data-bg-img="/img/bg/page-bg2.png"
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-5 col-lg-7 col-md-10">
              {/* Card */}
              <div className="card login-register-card">
                <div className="card-body">
                  <div className="text-center mb-5">
                    <h2>Login</h2>
                    <p>
                      Don't have an account yet?{" "}
                      <NavLink to="register.html" className="c1">
                        Register Now!
                      </NavLink>
                    </p>
                  </div>

                  <form action="#">
                    <div className="form-group">
                      <label htmlFor="email" className="mb-2">
                        Email Address
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        placeholder="anefty@gmail.com"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="password" className="mb-2">
                        Password
                      </label>
                      <input
                        type="password"
                        id="password"
                        className="form-control"
                        placeholder="*** **** *** ****"
                      />
                    </div>
                    <div className="d-flex pt-2">
                      <button type="submit" className="btn">
                        <img
                          src="/img/icons/btn-login.svg"
                          alt=""
                          className="svg"
                        />{" "}
                        login now
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* End Card */}
            </div>
          </div>
        </div>
      </div>
      {/* End Login */}
    </>
  );
}

export default Login;
